import React from 'react';
import svgbg from './images/svg1.svg'
import settings from './images/settings.webp'
import Logo from "assets/images/Logo.svg";

const MaintenancePage = () => {
  return (
    <div className="flex items-center justify-center min-h-screen gap-12 w-full">
      <div className='w-[40%]'>
        <div className="text-center px-6 py-8 bg-gradient7 text-white shadow-md rounded-xl ">
          <div className="flex justify-center">
            <div className='bg-white p-2 rounded-full'>
              <img src={settings} alt="" className='w-10' />
            </div>
          </div>
          <h1 className="text-4xl font-bold mb-4">Maintenance Notice!</h1>
          <p className="text-lg mb-4">
            Dear Users,
            <br />
            Our application is currently undergoing scheduled maintenance. During this time, access to the application may be temporarily unavailable. We apologize for any inconvenience caused and appreciate your patience.
            <br />
            Please check back shortly. Thank you for your understanding.
            <br />
            Sincerely,
          </p>
          <p className="text-lg font-bold">—</p>
          <div className="flex justify-center">
            <div className='bg-white px-2 py-2.5 rounded-full'>
              <img src={Logo} alt="" className='w-8' />
            </div>
          </div>
          <p className="text-lg font-bold">Soomuch.ai</p>
        </div>
      </div>
      <div className='w-[40%]'>
        <img src={svgbg} alt="Maintenance" className="w-full" />
      </div>
    </div>
  );
};

export default MaintenancePage;